import gql from "graphql-tag";

export const DELETE_AVATAR = gql`
    mutation DeleteAvatar {
        deleteAvatar (input: {}){
            user{
                profile{
                    avatarUrl
                }
            }
        }
    }
`;
